export const TASK_INDEX_START = 'TASK_INDEX_START';
export const TASK_INDEX_SUCCESS = 'TASK_INDEX_SUCCESS';
export const TASK_INDEX_FAILURE = 'TASK_INDEX_FAILURE';

export const ALERT_INDEX_START = 'ALERT_INDEX_START';
export const ALERT_INDEX_SUCCESS = 'ALERT_INDEX_SUCCESS';
export const ALERT_INDEX_FAILURE = 'ALERT_INDEX_FAILURE';

export const SYSTEM_MESSAGE_INDEX_START = 'SYSTEM_MESSAGE_INDEX_START';
export const SYSTEM_MESSAGE_INDEX_SUCCESS = 'SYSTEM_MESSAGE_INDEX_SUCCESS';
export const SYSTEM_MESSAGE_INDEX_FAILURE = 'SYSTEM_MESSAGE_INDEX_FAILURE';

export const CLEAR_ALL = 'CLEAR_ALL';

export const FATAL_FAILURE = 'FATAL_FAILURE';
